import * as types from '../mutation_types';

import commonApi from '../../service/common_api.js'

const Utils = require('../../lib/utils')

let user;

user = JSON.parse(Utils.getCookie('user'));

const state = {
    serverGameList: [],
    serverWorldList: [],
};

const getters = {

};

const actions = {
    getServerGame({commit}) {
        var tableName = 'login_info_game';
        commonApi.getConfs({
            tables: tableName
        }).then(res => {
            var sourceGameInfo = res[tableName];
            var loginInfoGame = [];
            let subInfo = [];
            for (let tmpItem of sourceGameInfo) {
                if ('0' === tmpItem.combine_server_number) {
                    //0为主服
                    tmpItem.children = [];
                    loginInfoGame.push(tmpItem);
                } else {
                    subInfo.push(tmpItem);
                }
            }

            for (let tmpItem of subInfo) {
                loginInfoGame.forEach(mainGameServer => {
                    if (tmpItem.combine_server_number === mainGameServer.server_number) {
                        mainGameServer.children.push(tmpItem);
                    }
                })
            }

            loginInfoGame.sort((a, b) => {
                let aServerNum = a.server_number>>0;
                let bServerNum = b.server_number>>0;

                if (aServerNum > bServerNum){
                    return 1;
                }
                if (aServerNum < bServerNum) {
                    return -1;
                }
                return 0;
            });

            commit(types.SET_SERVER_GAME,loginInfoGame)
        })
    },

    getServerWorld({commit}) {
        var tableName = 'login_info_world';
        commonApi.getConfs({
            tables: tableName
        }).then(res => {
            var sourceWorldInfo = res[tableName];
            var loginInfoWorld = [];
            let subInfo = [];
            for (let tmpItem of sourceWorldInfo) {
                if ('0' === tmpItem.combine_server_number) {
                    //0为主服
                    tmpItem.children = [];
                    tmpItem.game_servers = [];
                    loginInfoWorld.push(tmpItem);
                } else {
                    subInfo.push(tmpItem);
                }
            }

            for (let tmpItem of subInfo) {
                loginInfoWorld.forEach(mainServer => {
                    if (tmpItem.combine_server_number === mainServer.server_number) {
                        mainServer.children.push(tmpItem);
                    }
                })
            }

            for (let gameItem of state.serverGameList) {
                loginInfoWorld.forEach(worldItem => {
                    if (parseInt(gameItem.world_id) === worldItem.id) {
                        worldItem.game_servers.push(gameItem);
                    }

                    if (worldItem.children && worldItem.children.length > 0){
                        for (const subWorldInfo of worldItem.children) {
                            if (parseInt(gameItem.world_id) === subWorldInfo.id) {
                                worldItem.game_servers.push(gameItem);
                            }
                        }
                    }
                })
            }


            loginInfoWorld.sort((a, b) => {
                let aServerNum = a.server_order>>0;
                let bServerNum = b.server_order>>0;

                if (aServerNum > bServerNum) {
                    return 1;
                }
                if (aServerNum < bServerNum) {
                    return -1;
                }
                return 0;
            });

            commit(types.SET_SERVER_WORLD,loginInfoWorld)
        })
    },
};

const mutations = {
    [types.SET_SERVER_GAME](state, serverGameList) {
        state.serverGameList = serverGameList;
    },

    [types.SET_SERVER_WORLD](state, serverWorldList) {
        state.serverWorldList = serverWorldList;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/server.js